export default "__VITE_ASSET__xSB$$KyJ__"